// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"5b78e709","443":"1040fa42","840":"14f1f643"}[chunkId] + ".chunk.css";
};